import * as Sentry from '@sentry/react'

interface ReportErrorOptions {
    tags?: Record<string, string>
    extra?: Record<string, unknown>
}

export const reportError = (error: Error, options: ReportErrorOptions = {}): void => {
    try {
        Sentry.withScope((scope) => {
            if (options.tags) {
                Object.entries(options.tags).forEach(([key, value]) => {
                    scope.setTag(key, value)
                })
            }
            if (options.extra) {
                Object.entries(options.extra).forEach(([key, value]) => {
                    scope.setExtra(key, value)
                })
            }
            Sentry.captureException(error)
        })
    } catch {
        // swallow Sentry errors — don't impact app flow
    }
}

// Report network-related info to Sentry at info level.
// Keeps transient network errors out of exception telemetry but still records context.
export const reportNetworkInfo = (error: any, message = 'Network request failed after retries'): void => {
    try {
        Sentry.withScope((scope) => {
            scope.setLevel('info')
            scope.setTag('source', 'api')
            scope.setTag('network', 'no-response')
            scope.setTag('code', String(error?.code ?? 'unknown'))
            scope.setExtra('url', error?.config?.url)
            scope.setExtra('method', error?.config?.method)
            scope.setExtra('message', error?.message)
            scope.setExtra('request', error?.request)
            scope.setExtra('requestId', error?.requestId)
            scope.setExtra('traceId', error?.traceId)
            Sentry.captureMessage(message)
        })
    } catch {
        // swallow Sentry errors — don't impact app flow
    }
}

export default reportNetworkInfo
